<script setup lang="ts">
import type { IadAppRoute } from '~/application';

const route = useRoute();
const isMounted = useMounted();

const valuationLink = computed(() => {
  if (!isMounted.value) return {};
  const valuationRoute: IadAppRoute<'valuation-online-valuation'> = { name: 'valuation-online-valuation', params: {} };
  valuationRoute.query = { returnTo: route.path };
  return { to: valuationRoute };
});
</script>

<template>
  <div class="flex flex-col justify-center items-center text-center gap-m bg-secondary-40 rounded-xl p-l text-white">
    <Icon
      name="iad-icon:home-search"
      class="size-10"
    />
    <IadTitle
      tag="p"
      class="text-balance"
      :text="$t('property_serp.promo.valuation.title')"
    />
    <IadTitle
      tag="span"
      variant="x-small"
      class="text-pretty"
      :text="$t('property_serp.promo.valuation.subtitle')"
    />
    <IadBtn
      size="large"
      :to="valuationLink.to"
      :text="$t('property_serp.promo.valuation.cta')"
    />
  </div>
</template>
